import { setAuth } from "../store/auth/authSlice"
import { CheckEnStr } from "./check-en-str"

export const setGlobalErrorHandler = (addToast, axios, t, dispatch) => {
    axios.forEach(item => {
        item.interceptors.response.use(undefined, (err) => {
            if (err.config.url == "/auth/me") {
                throw err
            }
            if (err.response.data.statusCode === 401 && err.response.config.url!=="/auth/login") {
                dispatch(setAuth(1))
                throw err
            }
            if (err.response.data.statusCode === 403 ) {
                addToast(CheckEnStr("Unauthorized", t), {
                    appearance: 'error',
                    autoDismiss: true,
                })
                throw err
            }
            if (err.response.data.statusCode === 404 ) {
                throw err
            }

            if (err.response.data.statusCode === 500 ) {
                addToast((t("An error has occurred")), {
                    appearance: 'error',
                    autoDismiss: true,
                })
                throw err
            }

            

            if (err?.response?.data?.error) {
                addToast(CheckEnStr(err?.response?.data?.error, t), {
                    appearance: 'error',
                    autoDismiss: true,
                })
                throw err
            }
            if (err?.response?.data?.errors) {
                Object.keys(err?.response?.data?.errors).forEach(key => {
                    addToast(CheckEnStr(err?.response?.data?.errors[key].join(", "), t), {
                        appearance: 'error',
                        autoDismiss: true,
                    })
                })
                throw err
            }
            if (err?.response?.data?.message) {
                
                if (err?.response?.data.statusCode === 429) {
                    addToast(t("Too Many Requests"), {
                        appearance: 'error',
                        autoDismiss: true,
                    })
                    throw err
                }

                if (typeof err.response.data.message === 'string' || err.response.data.message instanceof String) {
                    addToast(CheckEnStr(err.response.data.message, t), {
                        appearance: 'error',
                        autoDismiss: true,
                    })

                    throw err
                }



                if (Array.isArray(err.response.data.message)) {
                    addToast(CheckEnStr(err.response.data.message.map(item => t(item)), t), {
                        appearance: 'error',
                        autoDismiss: true,
                    })
                    throw err;
                }


                Object.keys(err.response.data.message).forEach(key => {
                    addToast(CheckEnStr(err.response.data.message.map(item => t(item)).join(" , "), t), {
                        appearance: 'error',
                        autoDismiss: true,
                    })
                })
                throw err;

            }
            if (err?.response?.status) {
                addToast(CheckEnStr(err.response.status, t), {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }
            throw err;

        })
    })

}